var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.currentTerms),function(company,index){return _c('p-radio',{key:index,attrs:{"label":company},on:{"input":function($event){return _vm.emitEvent(company)}},model:{value:(_vm.companyTerms),callback:function ($$v) {_vm.companyTerms=$$v},expression:"companyTerms"}},[_vm._v("\n    "+_vm._s(company.toUpperCase())+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0afee739","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trg/CompanyTermsRadios.vue
// module id = DzSL
// module chunks = 10